import { getAllResidenciesAndFellowshipItems, getGlobals, getResidenciesAndFellowshipArchive } from "storyblok/api"
import { InlineCard } from "components/DynamicComponent/atoms/InlineCards"
import PageHeader from "components/DynamicComponent/atoms/PageHeader"
import CallToAction from "components/CallToAction"
import Meta from "components/Meta"
import richText from "utilities/richText"
import Wave from "public/assets/cta-banner.svg"
import StoryblokVisualEditor from "components/StoryblokVisualEditor"

export default function ResidenciesAndFellowshipsArchive({ residencies, story }) {
  const { twentysixty_seo } = story.content

  return (
    <>
      <Meta
        info={{
          title: twentysixty_seo?.title || "Arizona Spine Surgery Fellowships & Residencies | Sonoran Spine",
          og_title: twentysixty_seo?.title || "Arizona Spine Surgery Fellowships & Residencies | Sonoran Spine",
          twitter_title: twentysixty_seo?.title || "Arizona Spine Surgery Fellowships & Residencies | Sonoran Spine",
          description: twentysixty_seo?.description,
          og_description: twentysixty_seo?.description,
          twitter_description: twentysixty_seo?.description,
        }}
      />
      <main>
        <PageHeader blok={{ heading: "Spine Surgery Fellowships & Residency Programs in Arizona" }} />
        <section id="blog-section" className="lg:px-8">
          <div className="lg:flex max-w-screen-xl mx-auto pt-12 lg:pb-12">
            <div className="mb-12 lg:mb-0 lg:mr-12 xl:mr-24 px-8 lg:px-0 grid md:grid-cols-2 gap-12 lg:basis-2/3">
              {residencies.map((residency) => (
                <InlineCard title={residency.name} key={residency.name} link={residency.slug}>
                  {richText(residency.excerpt)}
                  <CallToAction href={residency.slug} style="purple">
                    Continue Reading
                  </CallToAction>
                </InlineCard>
              ))}
            </div>
            <div className="lg:basis-1/3">
              <div className="lg:sticky lg:top-12">
                <Wave className="skinny-wave" />
                <StoryblokVisualEditor story={story?.content}>
                  <div className="flex bg-navy -mt-1 flex-col justify-center items-center p-8 max-w-screen-xl mx-auto text-white text-center prose-h3:pb-6 prose-h3:uppercase">
                    {richText(story?.content?.sidebar_content)}
                  </div>
                </StoryblokVisualEditor>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}

export async function getStaticProps({ preview = null }) {
  const globals = await getGlobals()
  const residencies = await getAllResidenciesAndFellowshipItems()
  const story = await getResidenciesAndFellowshipArchive(preview)

  return {
    props: {
      globals,
      residencies,
      story: story ?? null,
      preview,
    },
  }
}
